"use client";

import { lazyHydrate } from "@ospweb/sdk-ui";

const BugReportPluginHydrated = lazyHydrate(
  () => import("./BugReportPlugin").then((mod) => mod.BugReportPlugin),
  {
    idleOptions: {
      enableIdleCallback: true,
    },
    ssr: false,
    loading: () => null,
  },
);

export function BugReportPluginHydratedRoot() {
  return <BugReportPluginHydrated />;
}
